import {
  collection,
  doc,
  getDocs,
  limit,
  orderBy,
  query,
  updateDoc,
  where,
} from 'firebase/firestore';
import { db } from '../firebase';

export interface PaymentRow {
  id: string;
  activityId?: string;
  paidById?: string;
  method?: string;
  amount?: number;
  status?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

const COLLECTION = 'payments';

export async function listPayments(options?: {
  status?: string;
  limitCount?: number;
}): Promise<PaymentRow[]> {
  const clauses: any[] = [];
  if (options?.status) {
    clauses.push(where('status', '==', options.status));
  }
  clauses.push(orderBy('createdAt', 'desc'));
  if (options?.limitCount) {
    clauses.push(limit(options.limitCount));
  }

  const snap = await getDocs(
    query(collection(db, COLLECTION), ...clauses)
  );

  return snap.docs.map((d) => {
    const data = d.data() as any;
    return {
      id: d.id,
      activityId: data.activityId,
      paidById: data.paidById,
      method: data.method,
      amount:
        typeof data.amount === 'number'
          ? data.amount
          : typeof data.amount === 'string'
          ? Number(data.amount)
          : undefined,
      status: data.status,
      createdAt: data.createdAt?.toDate ? data.createdAt.toDate() : undefined,
      updatedAt: data.updatedAt?.toDate ? data.updatedAt.toDate() : undefined,
    };
  });
}

export async function markPaymentAsPaid(id: string): Promise<void> {
  const ref = doc(db, COLLECTION, id);
  await updateDoc(ref, { status: 'paid' });
}

